import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tHallPolicyFileUpdate, tabsList, tHallPolicyFileId } from "@/api/portrayal/policy";
import fileModal from "@/components/dialog/common/uploadModal_tea.vue";
import { getList } from "@/api/system/role";
import { sysFileUpload } from "@/api/managementCenter/otherApi";
import quillEditorCom from "@/components/common/quillEditor.vue";
import treeMenu from "@/components/treeMenu/index.vue";
export default {
  name: "editModal",
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  components: {
    fileModal: fileModal,
    quillEditorCom: quillEditorCom,
    treeMenu: treeMenu
  },
  data: function data() {
    return {
      subDisabled: false,
      roleList: [],
      chooseDepartment: {
        state: false,
        data: {},
        showBox: false
      },
      fileData: {
        proName: "点击选择上传文件",
        isActive: true
      },
      formValidate: {
        title: null,
        fileType: 0,
        fileId: "",
        roleIds: [],
        id: "",
        deptId: "",
        deptName: "",
        content: ""
      },
      // 表单数据绑定
      ruleValidate: {
        content: [{
          required: true,
          message: "内容不能为空",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        fileType: [{
          required: true,
          message: "该项必须填写",
          trigger: "blur"
        }],
        roleIds: [{
          required: true,
          message: "权限不能为空",
          trigger: "change"
        }],
        deptName: [{
          required: true,
          message: "请选择部门",
          trigger: "change"
        }]
      },
      // 表单验证
      selectData: [],
      loading: false
    };
  },
  created: function created() {
    this.getRoleList();
  },
  methods: {
    getRoleList: function getRoleList() {
      var _this = this;

      getList().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          data.data.forEach(function (item) {
            item.roleId = String(item.roleId);
          });
          _this.roleList = data.data;
        } else {
          _this.$message.error(data.msg);
        }
      });
    },
    getForm: function getForm() {
      var _this2 = this;

      var o = this.editData.data;
      this.formValidate.title = o.title;
      this.formValidate.fileId = o.fileId;
      this.formValidate.id = o.id;
      this.formValidate.content = o.content;
      this.formValidate.deptId = o.deptId;
      this.formValidate.deptName = o.deptName;
      this.formValidate.fileType = o.fileType ? Number(o.fileType) : "";
      this.loading = true;
      tHallPolicyFileId(o.id).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.formValidate.roleIds = data.data.fileRole.map(function (item) {
            return item.roleId;
          });
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 更换部门名称弹框
    changeUserDept: function changeUserDept() {
      this.chooseDepartment.data = {};
      this.chooseDepartment.chooseBox = false;
      this.chooseDepartment.state = true;
    },
    nodeIdModal: function nodeIdModal(tree) {
      console.log(tree);
      this.chooseDepartment.data = tree;
    },
    // 新增-部门选择确认按钮
    depTreeBtn: function depTreeBtn() {
      this.formValidate.deptId = this.chooseDepartment.data.id;
      this.formValidate.deptName = this.chooseDepartment.data.name;
      this.chooseDepartment.state = false;
    },
    showAddData: function showAddData() {
      var _this3 = this;

      this.selectData = [];
      var data = [];
      var tabsData = [];
      var url = null; // if (this.$route.path == '/policyFile') {
      //     url = '/admin/dict/type/file_type'
      // } else {
      //     url = '/admin/dict/type/file_type_stu'
      // }

      url = "/admin/dict/type/policy_type";
      tabsList(url).then(function (res) {
        if (res.data.code == 0) {
          res.data.data.forEach(function (e) {
            var o = {
              id: Number(e.value),
              name: e.label,
              hasChildren: true
            };
            tabsData.push(o);
          });
          data = tabsData;
          data.forEach(function (e) {
            _this3.selectData.push(e);
          }); // this.selectData.unshift({
          //     name: '全部',
          //     id: 0,
          //     hasChildren: true,
          // });
          // let obj = {}; //数组对象去重
          // this.selectData = this.selectData.reduce(function (item, next) {
          //     obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
          //     return item;
          // }, []);
        }
      });
      /*if (this.addData.tabsId) {
                    this.formValidate.fileType = this.addData.tabsId;
                } else {
                    this.formValidate.fileType = 0
                }*/
    },
    closeModal: function closeModal() {
      this.$emit("closeEdit", false);
    },
    fileUpload: function fileUpload(files) {
      var _this4 = this;

      if (files.length > 0) {
        var fd = new FormData();
        fd.append("fromTarget", "0");
        fd.append("file", files[0]);
        sysFileUpload(fd).then(function (_ref3) {
          var data = _ref3.data;

          if (data.code == 0) {
            _this4.formValidate.title = data.data.fileName;
            _this4.subDisabled = false;
            _this4.formValidate.fileId = data.data.id;

            _this4.$refs.fileModal.getData("已选择上传文件", true);
          }
        }).catch(function (e) {// console.log(e);
        });
      }
    },
    submitForm: function submitForm(formNames) {
      var _this5 = this;

      this.$refs[formNames].validate(function (valid) {
        if (valid) {
          _this5.subDisabled = true;
          var obj = {};
          obj.fileRole = _this5.formValidate.roleIds.map(function (item) {
            return {
              roleId: String(item)
            };
          });
          obj = Object.assign(obj, _this5.formValidate);
          tHallPolicyFileUpdate(obj).then(function (res) {
            _this5.subDisabled = false;

            if (res.data.code == 0) {
              _this5.$message({
                message: "编辑成功",
                type: "success"
              });

              _this5.closeModal();

              _this5.$store.commit("clearDefaultChecked");
            } else {
              _this5.$message.warning(res.data.msg);
            }
          }).finally(function () {
            _this5.subDisabled = false;
          });
        }
      });
    }
  }
};